import { render, staticRenderFns } from "./choosecontacts.vue?vue&type=template&id=0363f404&scoped=true"
import script from "./choosecontacts.vue?vue&type=script&lang=js"
export * from "./choosecontacts.vue?vue&type=script&lang=js"
import style0 from "./choosecontacts.vue?vue&type=style&index=0&id=0363f404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0363f404",
  null
  
)

export default component.exports